// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NewCycleSelectHint-container-1byC6 {\n  position: relative;\n  min-width: 250px;\n}\n@media (max-width: 650px) {\n  .NewCycleSelectHint-container-1byC6 {\n    display: none;\n  }\n}\n.NewCycleSelectHint-si-content-width-max-m-SAKIs .NewCycleSelectHint-container-1byC6 {\n  display: none;\n}\n.NewCycleSelectHint-arrow-18jsr {\n  position: absolute;\n  top: -18px;\n  left: -5px;\n  height: 12px;\n}\n.NewCycleSelectHint-logo-17c6l {\n  margin-bottom: -0.4em;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "NewCycleSelectHint-container-1byC6",
	"si-content-width-max-m": "NewCycleSelectHint-si-content-width-max-m-SAKIs",
	"arrow": "NewCycleSelectHint-arrow-18jsr",
	"logo": "NewCycleSelectHint-logo-17c6l"
};
module.exports = exports;
